 
export enum Permission {
  None = 0,
  VerifyStatus = 1,
  MarkAsDispense = 2,
  MarkAsSample = 4,
  UndoDispense = 8,
  UndoSample = 16,
  MarkAsDestroyed = 32,
  ClearList = 64,
  Users = 128,
  Documentation = 256,
  TenantPreferences = 512,
  TenantCustomSettings = 1024,
  TenantProviderCredentials = 2048,
  AuditLogs = 4096,
  TermsOfUse = 8192,
  OfflineModeSimulator = 16384,
  UnregisterDevice = 32768,
  Tenant = 65536,
  Optel = 131072
}


// WEBPACK FOOTER //
// ./src/types/permission.ts